
export class User {
  constructor(
    public email: string,
    public password: string | null,
    public firstName?: string | null,
    public lastName?: string | null,
    public id?: string | null,
    public authToken?: string | null,
    public last_login?: Date,
    public accountadmin?: boolean,
    public dbadmin?: boolean,
    public userrole?: string,
  ) {}
}
